import { render, staticRenderFns } from "./JourneySection.vue?vue&type=template&id=1c84f655&lang=pug&"
import script from "./JourneySection.vue?vue&type=script&lang=js&"
export * from "./JourneySection.vue?vue&type=script&lang=js&"
import style0 from "./JourneySection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports